import EditOrganization from './EditOrganization';

export default EditOrganization;
